<template>
  <div class="load-dialog" style="text-align:center; max-width:500px;margin:0px auto;">
    <div class="download" style="margin:10px auto;">点击下载模板：
      <a target="_blank" href="javascript:void(0)" @click.prevent="downloadTemplate"> 货品批量修改模板.xlsx </a>
    </div>
    <el-upload v-loading="loading" class="upload-box" ref="upload" action="#" drag :on-change="handleChange"
      :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList" :http-request="submitUpload"
      :auto-upload="true" :limit="1">
      <el-icon style="font-size:3em;">
        <UploadFilled />
      </el-icon>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip">
        注：Excel表格里的填写项请严格按照模板内容进行填写
      </div>
    </el-upload>

    <div> 根据库房、款号以及货品批次号批量修改重量以及价格信息 </div>
  </div>
</template>
<script>
import { uploader } from "@/api/subupload";
import { boundModify, fetchBoundModifyTemplate } from "@/api/stock";
export default {
  name: "BoundModify",
  props: {
    companyId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      templateUrl: "",
      list: [],
      fileList: [],
    };
  },
  methods: {
    loadTemplateUrl() {
      return fetchBoundModifyTemplate().then((res) => {
        if (res.code !== 200 || !res.data) {
          this.$message.error(res.content || "模板地址获取失败");
          return "";
        }
        this.templateUrl = /^https?:\/\//.test(res.data) ? res.data : process.env.VUE_APP_BASEURL + res.data;
        return this.templateUrl;
      }).catch((err) => {
        this.$message.error((err && err.message) || "模板地址获取失败");
        return "";
      });
    },
    async downloadTemplate() {
      if (this.templateUrl) {
        window.open(this.templateUrl, "_blank");
        return;
      }
      const templateUrl = await this.loadTemplateUrl();
      if (templateUrl) {
        window.open(templateUrl, "_blank");
      }
    },
    //添加文件事件
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    //删除文件事件
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //超出个数事件
    handleExceed(file, fileList) {
      this.$message({
        message: "每次只能上传一个文件",
        type: "warning",
      });
    },

    //上传操作
    submitUpload(file) {
      console.log('upload');
      this.loading = true;
      var dataList = new FormData();
      dataList.append(file.file.name, file.file);
      dataList.append("fileType", "excel");
      dataList.append("dataType", "BoundModify");
      this.$refs.upload.clearFiles();

      uploader(dataList)
        .then((res) => {
          if (res.code === 200) {
            this.$message({ message: "上传成功", type: "success", });
            this.dataId = res.data[0].id;
          } else {
            this.$message.error("上传失败，请重试");
          }
        })
        .then(() => {
          this.loading = false;
          const companyID = this.companyId || '';
          if (!companyID) {
            this.$message.error("所属公司不能为空");
            return;
          }
          boundModify(this.dataId, companyID).then(
            (res) => {
              // if (res.code === 200) {
              //   this.list = Object.values({ ...res.data });
              // }
              this.$alert(res.content, '提示')
            },
            (err) => {
              //this.resList = err.data;
              this.$alert(JSON.stringify(err.data), '提示')
            }
          );
        });

      this.fileList = [];
    },
    download() {}
  },
  mounted() {
  },
  created() {
  }
};
</script>
<style lang="less"></style>
